const API_URL = '/api'; //'http://localhost:8002/api'

export const papersService = {
    // 기존 getPapers 메서드는 유지
    async getPapers(params) {
        const queryParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined) {
                queryParams.append(key, value);
            }
        });

        const response = await fetch(`${API_URL}/papers?${queryParams}`);
        if (!response.ok) {
            throw new Error('Failed to fetch papers');
        }
        return response.json();
    },

    // 새로운 getAuthors 메서드 추가
    async getAuthors(page = 1, limit = 20, search = '') {
        const queryParams = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString()
        });

        if (search) {
            queryParams.append('search', search);
        }

        const response = await fetch(`${API_URL}/authors?${queryParams}`);
        if (!response.ok) {
            throw new Error('Failed to fetch authors');
        }
        return response.json();
    }
};